'use client'

import { useActionState } from 'react'
import { login } from '../actions'
import { NeonButton } from '@/components/ui/NeonButton'
import Link from 'next/link'
import { ArrowRight, Loader2 } from 'lucide-react'

const initialState = {
  error: '',
}

export default function LoginPage() {
  const [state, formAction, isPending] = useActionState(login, initialState)

  return (
    <div className="glass-panel p-3 sm:p-4 relative">
        <h2 className="text-xl font-bold text-white mb-3 text-center">Welcome Back</h2>
        
        <form action={formAction} className="compact-form space-y-2">
            {/* Honeypot Field - Hidden from real users */}
            <div className="opacity-0 absolute top-0 left-0 h-0 w-0 overflow-hidden -z-50">
                <label htmlFor="zip_code_verify">Zip Code</label>
                <input type="text" name="zip_code_verify" id="zip_code_verify" tabIndex={-1} autoComplete="off" />
            </div>

            <div>
                <label className="block text-xs font-medium text-zinc-400 mb-1">Email</label>
                <input 
                    name="email" 
                    type="email" 
                    required 
                    className="input-field" 
                    placeholder="you@example.com"
                />
            </div>

            <div>
                 <label className="block text-xs font-medium text-zinc-400 mb-1">Password</label>
                <input 
                    name="password" 
                    type="password" 
                    required 
                    className="input-field"
                    placeholder="••••••••"
                />
            </div>

            {state?.error && (
                <div className="bg-red-500/10 border border-red-500/50 text-red-500 text-sm p-3 rounded-lg text-center">
                    {state.error}
                </div>
            )}

            <NeonButton className="w-full" disabled={isPending}>
                {isPending ? <Loader2 className="animate-spin w-5 h-5"/> : (
                    <>
                        Sign In <ArrowRight className="w-5 h-5" />
                    </>
                )}
            </NeonButton>
        </form>

        <div className="mt-4 text-center text-sm text-zinc-500">
            Don't have an account?{' '}
            <Link href="/signup" className="text-neon-cyan hover:text-neon-blue transition-colors font-medium">
                Sign up
            </Link>
        </div>
    </div>
  )
}
